


















































































































import DataTableInstallmentsSimple from '@/app/shared/components/data-tables/installments-simple.vue';
import {
  ContactBillingModel,
  CustomerBillingModel,
  InstallmentModel,
} from '@/app/shared/models';
import { refsService } from '@/app/shared/refs.service';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({ components: { DataTableInstallmentsSimple } })
export default class DialogGenerateLinkUpdateComponent extends Vue {
  @Prop(Array) readonly data!: InstallmentModel[];

  private installmentList: InstallmentModel[] = [];
  private loading = false;
  private dialog = false;
  private valueTab = '';
  private otherEmail = '';
  private EmailRequest = '';
  private openTable = this.data.length == 0 ? false : true;
  private saveEmail = false;
  private savePaymentInfoContract = false;

  private get refs() {
    return refsService;
  }
  private get rules() {
    return this.refs.static.rules;
  }

  private get contractModule() {
    return this.refs.modules.contract;
  }

  private clearFields() {
    this.otherEmail = '';
    this.saveEmail = false;
    this.valueTab = '';
    this.savePaymentInfoContract = false;
    this.dialog = false;
  }

  private get customer(): CustomerBillingModel {
    return this.refs.modules.contract.customer;
  }
  private get email() {
    return this.refs.modules.contract.email;
  }

  private async generateLink() {
    const listInstallments: string[] = [];
    this.loading = true;
    this.data.map(async (installment) => {
      listInstallments.push(installment.Id);
    });
    const updateContract =
      this.savePaymentInfoContract && listInstallments.length > 0;

    if (this.saveEmail == true) {
      const contactBillingMode: ContactBillingModel[] = [];
      const emails = this.email.Value.split(';') || [];
      emails.forEach((element) => {
        let canAdd = true;

        this.contractModule.customer.Contacts?.forEach((contact) => {
          if (element === contact.Value) {
            canAdd = false;
            return;
          }
        });

        if (canAdd) {
          const contact = new ContactBillingModel(
            this.refs.enums.ContactType.Email,
            'Email'
          );
          contact.Value = element;
          contactBillingMode.push(contact);
        }
      });

      await this.contractModule.addContact({
        contractId: this.contractModule.contract.Id,
        customerId: this.contractModule.customer.Id,
        contact: contactBillingMode,
      });
    }

    this.refs.modules.contract
      .generateLinkUpdate({
        contractId: this.contractModule.contract.Id,
        installmentList: listInstallments,
        updateContract: updateContract,
        emails: this.email.Value,
      })
      .then(async () => {
        this.$toast.success(this.$t('toasts.send_email_successfully'));
        this.dialog = false;
        this.refs.modules.ticket.SET_EDIT_INSTALLMENT_GENERATE(true);
      })
      .catch(() => {
        this.$toast.error(this.$t('toasts.error_send_email'));
      })
      .finally(() => (this.loading = false));
  }
  @Watch('dialog')
  private onChangeDialog(value: boolean): void {
    this.valueTab = localStorage.getItem('tabulacao') ?? '';
    if (value) {
      const installmentLast = this.refs._.maxBy(
        this.refs.modules.contract.installmentList,
        'Number'
      );
      this.installmentList = this.refs._.map(this.data, (installment) => {
        return {
          Id: this.refs.util.generateGuid(),
          Status: this.refs.enums.InstallmentStatus.Generated,
          OriginalDueDate: this.refs.moment().format('YYYY-MM-DD'),
          Reference: {
            Year:
              installmentLast?.Reference?.Year ||
              installmentLast?.YearReference,
            Month:
              (installmentLast?.Reference?.Month ||
                installmentLast?.MonthReference ||
                0) + 1,
          },
          Value: installmentLast?.Value,
          OurCode: installment.OurCode,
          Number: installmentLast?.Number ? installmentLast.Number + 1 : 0,
          InstallmentType: installment.InstallmentType,
        };
      });
    }
  }
}
